module.exports = __webpack_public_path__ + "static/img/icon_my_arrow_down_gray.4c8895f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_my_arrow_down_gray.svg
// module id = 8RoW
// module chunks = 10